import React, { Component } from "react";

var configs = require("../../../public/config.json");

export default class CountdownTimer extends Component {
  //burası component bazlı dinamik hale gelmeli
  state = {
    time: configs.smsVerificationKeyTimeout || 120
  };
  componentDidMount() {
    this.startCountDown();
  }
  componentWillUnmount() {
    clearInterval(this.intervalHandle);
  }
  tick = () => {
    const { onTimeout } = this.props;
    const { time } = this.state;
    this.setState(
      {
        time: time - 1
      },
      () => {
        if (!this.state.time) {
          clearInterval(this.intervalHandle);
          onTimeout();
        }
      }
    );
  };
  startCountDown = () => {
    this.intervalHandle = setInterval(this.tick, 1000);
  };
  render() {
    const { time } = this.state;
    return <span>{time} sec</span>;
  }
}
